import { OFFER_TABLE_VIEWED } from './types';

export const offerTableIsViewed = (length, sectionTitle, pageNumber) => ({
  type: OFFER_TABLE_VIEWED,
  length,
  sectionTitle,
  pageNumber,
});
